export const countVacancies = async (type: 'fysio' | 'fit'): Promise<number> => {
	const {
		data: vacancies,
	} = await useAsyncData(`vacancy-count-${type}`, () =>
		queryCollection('vacancies').where('organization', '=', type).count()
	);

	return vacancies.value ?? 0;
};
